import { HiOutlineArrowLeft } from "react-icons/hi";
import { useParams, Link } from "react-router-dom";
import projects from "../data/projects";

const ProjectDetails = () => {
    const { id } = useParams();
    const project = projects.find((p) => p.id === id);

    if (!project) return null;

    const hasImage = project.image && project.image.trim() !== "";

    return (
        <div className="project-details-container">

            <Link to="/" className="back-icon">
                <HiOutlineArrowLeft size={28} />
            </Link>

            <h1 className="project-title">{project.title}</h1>

            {hasImage ? (
                <img
                    src={project.image}
                    alt={project.title}
                    className="project-main-image"
                />
            ) : (
                <div
                    className="project-fallback"
                    style={{ backgroundColor: project.bgColor || "#222" }}
                >
                    <img src={project.logo} alt={project.title} className="fallback-logo-lg" />
                </div>
            )}

            <p className="project-description">{project.description}</p>

            {project.link && (
                <a href={project.link} className="project-link" target="_blank" rel="noopener noreferrer"
                >
                    Visit Website
                </a>
            )}
        </div>
    );
};

export default ProjectDetails;
